import axios from "axios";
import { Result } from "@/models/Result";
import { CheckChannelCampaignsData } from "@/models/campaigns/CheckChannelCampaignsData";
import { CheckFacebookTokenData } from "@/models/campaigns/CheckFacebookTokenData";
import { FacebookCampaign } from "@/models/campaigns/FacebookCampaign";
import { requestConfig } from "./ApiService";
import ConfigService from "../ConfigService";

export default {
  checkToken(campaignId: number, manual: boolean): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookCheckTokenUrl);
      const config = {
        ...requestConfig,
        params: {
          channelId: campaignId,
          manual
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          const data: CheckFacebookTokenData = {
            hasPermissions: response.data.hasPermissions,
            isValid: response.data.isValid,
          };
          resolve({
            Data: data,
            Message: response.data.message,
            Success: response.data.success
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  clearTemplateFacebook(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookClearChannelCampaignsUrl);
      const config = {
        ...requestConfig,
        params: {
          channelId: campaignId,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          resolve({
            Message: response.data.Message,
            Success: response.data.Status === "success"
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  connectCampaign(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookLoginChannelCampaignsUrl);
      const win = window.open(url + "?channelId=" + campaignId, "Facbook pages", 'width=800,height=450');
      const checkWinClosed = setInterval(function () {
        if (win && win.closed) {
          const config = {
            ...requestConfig,
            params: {
              channelId: campaignId,
            },
          };
          const checkChannelCampaignsUrl = new URL(ConfigService.facebookCheckChannelCampaignsUrl);
          axios
            .post(checkChannelCampaignsUrl.toString(), null, config)
            .then((response) => {
              const data: CheckChannelCampaignsData = {
                adGroups: response.data.adSets,
                adGroupsCount: response.data.adSetsCount,
                campaignCount: response.data.campaignCount,
                campaigns: response.data.campaigns,
              };
              resolve({
                Data: data,
                Message: response.data.Message,
                Success: response.data.Status === "success"
              });
            })
            .catch((error) => {
              reject(error);
            });
          clearInterval(checkWinClosed);
        }
      }, 200);
    });
  },

  getFacebookCampaign(id: string): Promise<FacebookCampaign> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookCampaignUrl);
      const config = {
        ...requestConfig,
        params: {
          id,
        },
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          const result: FacebookCampaign = response.data;
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getFacebookConnectData(companyId?: number, checklistClientId?: number, message?: string): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookConnectDataUrl);
      const config = {
        ...requestConfig,
        params: {
          checklistClientId,
          companyId,
          message,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          const result: Result = response.data;
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loginCustomer(companyId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookLoginCustomerUrl);

      const w = 950;
      const h = 450;
      const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;
      const systemZoom = width / window.screen.availWidth;
      const left = (width - w) / 2 / systemZoom + dualScreenLeft;
      const top = (height - h) / 2 / systemZoom + dualScreenTop;

      const win = window.open(
        url + "?companyId=" + companyId,
        "windowname1",
        "width=" + w / systemZoom + ", height=" + h / systemZoom + ", top=" + top + ", left=" + left
      );
      const checkWinClosed = setInterval(function () {
        if (win && win.closed) {
          clearInterval(checkWinClosed);
          const result: Result = {
            Message: "",
            Success: true,
          };
          resolve(result);
        }
      }, 200);
    });
  },

  repairToken(campaignId: number): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookRepairTokenUrl);
      window.open(url + "?channelId=" + campaignId, "Facbook pages", 'width=580, height=400');
    });
  },

  sendConnectMessage(email: string, clientName: string, msg: string): Promise<Result> {
    return new Promise((resolve, reject) => {
      const url = new URL(ConfigService.facebookSendConnectMessageUrl);
      const config = {
        ...requestConfig,
        params: {
          clientName,
          email,
          msg,
        }
      };
      axios
        .post(url.toString(), null, config)
        .then((response) => {
          resolve({
            Message: response.data.message,
            Success: response.data.success,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
